import { render, staticRenderFns } from "./AlertAutoDismissible.vue?vue&type=template&id=208b83ce"
import script from "./AlertAutoDismissible.vue?vue&type=script&lang=js"
export * from "./AlertAutoDismissible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports